<div class="ir-item-line th-filter" *ngIf="inspection?.sections?.length">
  <div (click)="setOrderBy('etag')" class="ir-item-cell s2 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'inspections.last-modified-date' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('name')" class="ir-item-cell s8 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.name' | translate }}
    </span>
  </div>
</div>
<div class="ir-item-empty ir-mv8" *ngIf="inspection?.sections?.length == 0">
  <div class="ir-section--list">
    <p>
      <span>{{ 'inspections.no-sections' | translate }}</span>
    </p>
  </div>
</div>
<div
  class="ir-content-flow"
  *ngIf="inspection?.sections?.length"
  [ngClass]="inspection?.sections?.length ? 'has-filter has-actions' : ''"
>
  <div class="ir-section--list">
    <div *ngIf="inspection">
      <div
        class="ir-item-line th-section clickable indent"
        [ngClass]="section.selected ? 'selected' : ''"
        (click)="openSection(section)"
        *ngFor="let section of inspection?.sections | orderBy : orderByFieldName : direction | searchBy : query"
      >
        <div class="ir-item-cell s2">
          <div class="ir-item-selector" (click)="selectSection($event, section)">
            <i class="material-icons" *ngIf="!section.selected">check_box_outline_blank</i>
            <i class="material-icons" *ngIf="section.selected">check_box</i>
          </div>
          <span>{{ section?.etag | formatDate }}</span>
        </div>
        <div class="ir-item-cell s8">
          <span>{{ section.name }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
